export default __webpack_public_path__ + "static/logo-302066d6b55c523cf9c38e870ff30b64.png";